<template>
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Global - Detalhes Dr. Achei</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
           <div class="element-wrapper pb-0">
               <div class="">
          <div class="text-right">
            <b-button v-b-toggle.collapse-1 variant="primary">
                <i class="fa fa-filter"></i>
                Filtros 
            </b-button>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card header="Filtros para aplicar">
              <div class="container">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <label>Empresa</label>
                      <multiselect 
                        v-model="filtro.empresa"
                        :multiple="true"
                        label="name"
                        value="_id"
                        track-by="_id"
                        placeholder="Selecione uma empresa"
                        :showLabels="false"
                        :options="empresas"
                        ></multiselect>    
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label> Data Emissão Inicial:</label>
                      <datepicker 
                      calendar-button-icon="fa fa-calendar-alt" 
                      clear-button
                      :disabled-dates="disabledData"
                      bootstrap-styling 
                      calendar-button 
                      v-model="filtro.dataEmissaoInicial"
                      >
                      </datepicker>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label> Data Emissão Final:</label>
                        <datepicker
                        calendar-button-icon="fa fa-calendar-alt" 
                        clear-button 
                        :disabled-dates="disabledData"
                        bootstrap-styling 
                        calendar-button 
                        v-model="filtro.dataEmissaoFinal">
                        </datepicker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                      <div class="form-group">
                          <label>Data Vencimento Inicial:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataVencimentoInicial">
                              </datepicker>
                      </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                        <label>Data Vencimento Final:</label>
                            <datepicker 
                            calendar-button-icon="fa fa-calendar-alt" 
                            clear-button
                            :disabled-dates="disabledData"
                            bootstrap-styling 
                            calendar-button 
                            v-model="filtro.dataVencimentoFinal">
                            </datepicker>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                      <div class="form-group">
                          <label> Data Pagamento Inicial:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button 
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataPagamentoInicial"></datepicker>
                      </div>
                  </div>
                  <div class="col-4">
                      <div class="form-group">
                          <label>Data Pagamento Final:</label>
                              <datepicker 
                              calendar-button-icon="fa fa-calendar-alt" 
                              clear-button 
                              :disabled-dates="disabledData"
                              bootstrap-styling 
                              calendar-button 
                              v-model="filtro.dataPagamentoFinal"></datepicker>
                      </div>
                  </div>
                </div>
                  <div class="row text-right">
                    <div class="col">
                      <b-link @click="limpar" class="mr-2">Limpar</b-link>
                      <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                    </div>
                  </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
               <b-card style="margin:10px">
                    <div class="container" >
                        <div class="row">
                            <div class="col">
                                <label for>Quantidade Empresas</label>
                                <h5>{{resultado.empresas}}</h5>
                            </div>
                            <div class="col">
                                <label for>Total Clientes</label>
                                <h5>{{resultado.qtdClientes}}</h5>
                            </div>
                            <div class="col">
                                <label for>Clientes Pagos</label>
                                <h5>{{resultado.qtdClientesPagos}}</h5>
                            </div>
                        </div>
                         <hr />
                        <div class="row">
                            <div class="col">
                                <label>Faturas</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for>Total Valor:</label>
                                <h5>{{(resultado.totalVendido || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Total Pago:</label>
                                <h5>{{(resultado.totalPago || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Total Vencimento:</label>
                                <h5>{{(resultado.totalVencido || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Total Aguardando:</label>
                                <h5>{{(resultado.totalAguardando || 0)|money}}</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for>Numero de Faturas</label>
                                <h5>{{resultado.totalFatura}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Numero de Faturas Pagas</label>
                                <h5>{{resultado.faturasPago}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Numero de Faturas Vencidas</label>
                                <h5>{{resultado.faturasVencida}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>numero de Faturas Aguardando</label>
                                <h5>{{resultado.faturaAguardando}}</h5>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col">
                                <label>Tipos Pagamentos</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label for>Boleto</label>
                                <h5>{{(resultado.totalBoleto || 0)|money}} </h5>
                            </div>
                            <div class="col-6">
                                <label for>Cartão de Crédito</label>
                                <h5>{{(resultado.totalCartao || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Dinheiro</label>
                                <h5>{{(resultado.totalDinheiro || 0)|money}}</h5>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-6">
                                <label for>Repasse sem Contar Baixa Manual</label>
                                <h5>{{(resultado.totalrepasseEmpresa || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Total com a Dr.Achei</label>
                                <h5>{{(resultado.totalComDrachei || 0)|money}}</h5>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col">
                                <label>Total Final</label>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-6">
                                <label for>Repasse Final para a(s) empresa(s)</label>
                                <h5>{{(resultado.repasseEmpresaFinal || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                                <label for>Dr.achei com Imposto</label>
                                <h5>{{(resultado.repasseDrAcheiFinal || 0)|money}}</h5>
                            </div>
                            <div class="col-6">
                            </div>
                            <div class="col-6">
                                <label for>Imposto</label>
                                <h5>{{(resultado.imposto || 0)|money}}</h5>
                            </div>
                        </div>
                        <hr />
                    </div>
               </b-card>
           </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
export default {
    async mounted(){
        const empresa = await axios.get(`/api/juridica/?select=name%20_id`);
        this.empresas = empresa.data
        
        this.find();
  },
  computed:{
    baseURL(){
        return axios.defaults.baseURL;
    },
    formasPagamento() {
        return this.$store.getters.formasPagamento;
    },
    statusCobranca () {
        return this.$store.getters.statusCobranca;
    },
    statusPedido() {
        return this.$store.getters.statusPedido;
    },
    exibicaoFiltro() {
        return this.$store.getters.exibicaoFiltro;
    },
    filtro() {
      return this.$store.getters.filtro;
    }
  },
  data(){
    var dataInicial = moment().toDate();
    var dataFinal = moment().subtract("2","month").startOf("month").toDate();
    return{
        exibirFiltro:false,
        empresas:[],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        items: [],
        disabledData:{
          to:dataFinal,
          from:dataInicial
        },
        mostrarFiltros:{},
        resultado:{},
    }
  },
  components: {
    datepicker,
    Multiselect
  },
  methods:{
    voltar() {
      window.history.back();
    },
    limpar() {
      this.filtro = {}
      this.mostrarFiltros={}
    },
    async find(){
      try {
        this.$store.dispatch("setLoading",true);
        await this.$store.dispatch('setFiltro', this.filtro);
        const resposta = await this.$store.dispatch('findDrAchei');
        const resultado = resposta.data;
        this.resultado=resultado;
      } catch (error) {
          alert(error.message);
      } finally {
          this.$store.dispatch("setLoading",false);
      }
    }
  }
}
</script>